export enum PREarnCodeMethodConstants {
  Amount = 'A',
  Hours = 'H',
  Allowance = 'L',
  Routine = 'R',
  Standard = 'S',
}

export enum PREarnCodeROECategoryConstants {
  Vacation = 'V',
  OtherMonies = 'OM',
}

export enum PREarnCodeCategoryConstants {
  AllowanceTaxable = 'AT',
  AllowanceNonTaxable = 'ANT',
  LumpSumE = 'LSE',
}
